import http from '../jslibs/axios/http';
import dkAxiosFile from '@/jslibs/axios/axios-file';

export const login = data => http.post('/common/AdminLogin', data);

//系统配置
export const settingList = data => http.post('/admin/admin.setting/read', data);

//获取图片验证码
export const getCaptcha = data => http.get('/common/Captcha', data);

//修改系统配置
export const settingListupdate = data => http.post('/admin/admin.setting/update', data);

//获取所有菜单项
export const menulist = (data) => http.get('/admin/admin.menu/index', data);

//export const menulist = data => http.get('/cms/admin/permissions/new', data);

//获取所有行业名称列表
export const industrylist = () => http.get('/cms/order/industry');

//获取操作列表
export const logList = data => http.get('/cms/admin/log', data);

//获取七牛信息
export const qiniuInfo = () => http.post('/common/UploadFile');

export const getSetting = () => http.get('/cms/SystemSetting');
export const changeSetting = (uuid, data) => http.put(`/cms/SystemSetting/${uuid}`, data);

//上传图片
// export const uploadImg = (data)=> http.post('http(s)://upload-z2.qiniup.com', data)

export const uploadFile = (data) => dkAxiosFile({
	url: '/common/Upload',
	headers: {
		'content-type': 'multipart/form-data'
	},
	method: 'POST',
	data
});


export const uploadImgFile = (url,data) => dkAxiosFile({
	url: url,
	headers: {
		'content-type': 'multipart/form-data'
	},
	method: 'POST',
	data
});
